import React from "react";
import SearchImage from "../../images/search.png";

const EmptyCard = ({
  title = "No Data Found",
  message = "No data available. Create your first entry.",
}) => {
  return (
    <div className="inventory-state-container">
      <img src={SearchImage} alt="" className="state-image" />
      <h2 className="state-title">{title}</h2>
      <p className="state-message">{message}</p>
    </div>
  );
};

export default EmptyCard;
